import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Search, RefreshCw } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { CouponDiagnosticResult } from "./CouponDiagnosticResult";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CouponDiagnostics = ({ selected }) => {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);
  const section = useRef(null);
  const inspect = useCallback(async (value, checkEmail) => {
    if (!value.trim()) return;
    const id = ++requestId.current;
    setLoading(true); setError(""); setData(null);
    try {
      const params = { code: value.trim().toUpperCase() };
      if (checkEmail !== undefined) params.email = checkEmail.trim();
      const response = await axios.get(`${API}/coupons/diagnostics`, { params });
      if (id === requestId.current) setData(response.data);
    } catch (err) {
      if (id === requestId.current) setError(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Verifica non disponibile. Riprova tra poco.");
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }, []);
  useEffect(() => {
    if (!selected?.code) return;
    setCode(selected.code); setEmail(""); inspect(selected.code);
    section.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [selected, inspect]);
  useEffect(() => () => { requestId.current += 1; }, []);

  return (
    <section ref={section} className="border-y border-gray-700 py-6 mb-6 min-w-0 scroll-mt-6" data-testid="coupon-diagnostics">
      <h2 className="text-lg font-semibold text-white mb-4">Verifica codice sconto</h2>
      <form onSubmit={(event) => { event.preventDefault(); inspect(code); }} className="flex flex-col sm:flex-row gap-2">
        <label className="flex-1 min-w-0 text-sm text-gray-300" htmlFor="coupon-diagnostic-search">Codice
          <Input id="coupon-diagnostic-search" data-testid="coupon-diagnostic-search" value={code} maxLength={100} placeholder="BENVENUTO-…" autoComplete="off" className="mt-1 bg-gray-900 border-gray-600 text-white font-mono" onChange={(event) => { setCode(event.target.value.toUpperCase()); setData(null); setError(""); requestId.current += 1; setLoading(false); }} />
        </label>
        <Button type="submit" disabled={loading || !code.trim()} className="sm:self-end bg-pink-600 hover:bg-pink-700" data-testid="coupon-diagnostic-submit"><Search className="w-4 h-4 mr-2" />{loading ? "Controllo…" : "Verifica codice"}</Button>
      </form>
      {error && <p role="alert" className="text-rose-300 mt-3 text-sm" data-testid="coupon-diagnostic-error">{error}</p>}
      {loading && <p role="status" className="text-gray-400 mt-3" data-testid="coupon-diagnostic-loading">Verifica in corso…</p>}
      {data && <>
        <CouponDiagnosticResult data={data} />
        {data.found && <form onSubmit={(event) => { event.preventDefault(); inspect(data.code, email); }} className="flex flex-col sm:flex-row gap-2 mt-5 pt-4 border-t border-gray-700">
          <label htmlFor="coupon-diagnostic-email" className="flex-1 min-w-0 text-sm text-gray-300">Email usata dal cliente
            <Input id="coupon-diagnostic-email" data-testid="coupon-diagnostic-email" type="email" maxLength={254} value={email} onChange={(event) => setEmail(event.target.value)} className="mt-1 bg-gray-900 border-gray-600 text-white" placeholder="cliente@esempio.it" />
          </label>
          <Button type="submit" disabled={loading} className="sm:self-end bg-gray-700 hover:bg-gray-600" data-testid="coupon-diagnostic-email-submit"><RefreshCw className="w-4 h-4 mr-2" />Verifica email</Button>
        </form>}
      </>}
    </section>
  );
};